import React from "react";
import { ContactSocial, SocialLink } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface ContactSocialProps {
  blok?: ContactSocial & SbBlokData;
}

const ContactSocialComponent: React.FC<ContactSocialProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, socials } = blok;

  const renderSocialLink = (social: SocialLink) => {
    if (!social) return null;

    const { platform, title, url } = social;

    const platformIconClass = () => {
      switch (platform) {
        case "youtube":
          return "fa-youtube text-youtube";
        case "linkedin":
          return "fa-linkedin text-linkedin";
        case "facebook":
          return "fa-facebook text-facebook";
        case "twitter":
          return "fa-twitter text-twitter";
        default:
          return "";
      }
    };

    const renderUrl = () => {
      return url?.cached_url || "#";
    };

    return (
      <div className="col text-center">
        <a
          href={renderUrl()}
          target="_blank"
          rel="noopener"
          className="text-decoration-none d-block"
        >
          <div>
            <i className={`fab fa-5x mb-2 ${platformIconClass()}`}></i>
          </div>
          {title && <h4 className="mb-2 text-decoration-none">{title}</h4>}
        </a>
      </div>
    );
  };

  return (
    <div {...storyblokEditable(blok)} className="bg-light">
      <div className="container py-4 py-md-5">
        {title && <h2 className="text-center mb-4">{title}</h2>}
        {socials && socials.length > 0 && (
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 gy-4 gy-md-0 text-center justify-content-center">
            {socials.map((social) => (
              <React.Fragment key={social._uid}>{renderSocialLink(social)}</React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSocialComponent;